import React from 'react';
import classNames from 'classnames';
import {FormattedMessage} from 'react-intl';
import handlePostLoginRedirect from '../../utilities/handle-post-login-redirect';

const LoginPrompt = React.memo(({ postId }) => {
    const handleLoginClick = () => {
        handlePostLoginRedirect(postId);
    };

    return (
        <div className='padding-top-0dot75rem'>
            <button
                onClick={handleLoginClick}
                className='background-color-transparent border-style-none color-warning-600 text-sm cursor-pointer hover-color-warning-700 font-weight-500 text-decoration-underline'
            >
                <FormattedMessage defaultMessage='Sign in to interact with posts' />
            </button>
        </div>
    );
});

export default LoginPrompt;
